import type { OrderType } from '@/pages/store/store-detail.types';

interface StoreDetailTabsProps {
  selectedOrderType: OrderType;
  onOrderTypeChange: (type: OrderType) => void;
}

export function StoreDetailTabs({ selectedOrderType, onOrderTypeChange }: StoreDetailTabsProps) {
  return (
    <>
      {/* 주문 유형 선택 탭 */}
      <div className="px-4 mb-4">
        <div className="flex border-2 border-[#DEDEDE] rounded-xl overflow-hidden">
          {(['DEADLINE_DISCOUNT', 'RESERVATION_DISCOUNT', 'REGULAR_ORDER'] as const).map((type) => (
            <button
              key={type}
              onClick={() => onOrderTypeChange(type)}
              className={`py-2.5 px-2.5 text-xl font-bold transition-colors ${
                selectedOrderType === type
                  ? 'bg-[#86DB89] text-white flex-[140]'
                  : 'bg-white text-[#222222] flex-[120]'
              }`}
            >
              {type === 'DEADLINE_DISCOUNT' ? '마감할인' : type === 'RESERVATION_DISCOUNT' ? '예약할인' : '일반주문'}
            </button>
          ))}
        </div>
      </div>
      
      {/* 주문 유형 안내 */}
      {selectedOrderType === 'DEADLINE_DISCOUNT' && (
        <div className="px-8 mb-6">
          <div className="border-b border-[#222222] pb-1 text-center">
            <p className="text-sm font-medium text-[#222222]">
              오늘 만든 식품을 마감 전 할인하여 판매하는 상품입니다
            </p>
          </div>
        </div>
      )}
      
      {selectedOrderType === 'RESERVATION_DISCOUNT' && (
        <div className="px-8 mb-6">
          <div className="border-b border-[#222222] pb-1 text-center">
            <p className="text-sm font-medium text-[#222222]">
              전날 예약하고 내일 할인된 시간에 수령하는 상품입니다
            </p>
          </div>
        </div>
      )}
      
      {selectedOrderType === 'REGULAR_ORDER' && (
        <div className="px-8 mb-6">
          <div className="border-b border-[#222222] pb-1 text-center">
            <p className="text-sm font-medium text-[#222222]">
              일반 주문하여 당일 수령하는 일반가격 상품입니다
            </p>
          </div>
        </div>
      )}
    </>
  );
}